import home from "./home";
import tabbar from "./tabbar";
import my from "./my";
import login from "./login";
import orderItem from "./order/orderItem";
import repayMethods from "./order/repayMethods";
import basicInformation from "./information/basicInformation";
import idCard from "./information/idCard";
import other from "./information/other";
import work from "./information/work";
import bankCard from "./bankCard";
import router from "./router";
import request from "./request";
import unit from './unit';
import orderStatus from './orderStatus';
import download from './download';
import common from './common';

export default {
  home,
  tabbar,
  my,
  login,
  orderItem,
  repayMethods,
  basicInformation,
  idCard,
  other,
  work,
  bankCard,
  router,
  request,
  unit,
  orderStatus,
  download,
  common
}
